<template>
  <li class="list-item" :class="align">
    <slot></slot>
  </li>
</template>

<script>
export default {
  components: {},
  props: {
    config: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    align(){
      return this.config.attrs.textAlign || '';
    }
  }
};
</script>

<style lang="scss" scoped>
.list-item {
  &.center {
    text-align: center;
  }

  &.right {
    text-align: right;
  }
}
</style>